import { useEffect, useRef } from "react";
import {
  applyOrganizationBrandingFromApi,
  clearOrganizationBrandingLoadState,
  getSellerOrgApiCode,
} from "../config/sellerOrgConfig";
import {
  getOrganizationDetails,
  type OrganizationApiDetails,
} from "../service/organization/organizationService";

/**
 * Fetches organization branding (logo, favicon, WhatsApp) on app load
 * and merges into seller org config. Safe to call on public auth pages.
 */
export function useOrganizationBrandingBootstrap(): void {
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) {
      return;
    }
    fetchedRef.current = true;

    const orgCode = getSellerOrgApiCode();
    if (!orgCode) {
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const response = await getOrganizationDetails(orgCode);
        if (cancelled) {
          return;
        }
        const data = response?.data?.data as OrganizationApiDetails | undefined;
        if (data) {
          applyOrganizationBrandingFromApi(data);
        } else {
          clearOrganizationBrandingLoadState();
        }
      } catch (error) {
        clearOrganizationBrandingLoadState();
        console.warn("[useOrganizationBrandingBootstrap] Failed to load organization branding:", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);
}
